import cabri from "../app/cabri-app";
import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";

import {Cabrilog} from  "../app/log";

/**
 *
 */
class RenderableMesh extends GeomObject {
    constructor (objectId, peeredClass) {
        super(objectId);
        this.peeredClass = peeredClass;
        this.rawCoords2 = [];
        this.rawCoords1 = [];
        this.mesh2 = null;      // surface made mostly of coplanar triangles
        this.meshs1 = [];       // tubes
        this.drawDim1 = true; this.drawDim2 = true;
        if (objectId !== 0) {
            this.curve_radius =
                super.getFloatStyleAttribute("curve_radius", 1.0);
            this.color = super.getColorAttribute("surface_color1", "#7F7F7F");
            this.curveColor = super.getColorAttribute("curve_color1",   "#717171");
        }
    }

    updateFromPeer () {
        if (this.alreadyCheckedInLastCycle)
            return this.updatedInLastCycle;
        let newCoords2 = null, newCoords1;
        try {
            newCoords2 = cabri.emsc.renderAsMesh(this.objectId, 2);
            if (this.mesh2 == null ||
                newCoords2.length !== this.rawCoords2.length)
                    this.updatedInLastCycle = true;
            else {
                for (let i = 0; i < newCoords2.length; i++) {
                    if (this.rawCoords2[i] !== newCoords2[i]) {
                        this.updatedInLastCycle = true;
                        break;
                    }
                }
            }
            if (this.updatedInLastCycle || this.forceUpdateInNextCycle) {
                this.forceUpdateInNextCycle = false;

                let sameCounts = true;
                // dim-2 coords have changed, need to rebuild
                if (newCoords2.length !== this.rawCoords2.length) {
                    this.rawCoords2 = new Array(newCoords2.length);
                    sameCounts = false;
                }
                for (let i = 0; i < newCoords2.length; i++)
                    this.rawCoords2[i] = newCoords2[i];

                // also rebuild dim-1 coords
                newCoords1 = cabri.emsc.renderAsMesh(this.objectId, 1);
                if (this.rawCoords1.length !== newCoords1.length) {
                    this.rawCoords1 = new Array(newCoords1.length);
                    sameCounts = false;
                }
                for (let i = 0; i < newCoords1.length; i++)
                    this.rawCoords1[i] = newCoords1[i];

                if (sameCounts)
                    this.updateMeshes();
                else
                    this.createMeshes();
            }
        } catch (e) {
            console.log(`Issue at updating renderable mesh ${this.objectId}.`, e);
        } finally {
            if (newCoords2)
                cabri.emsc._free(newCoords2);
            if (newCoords1)
                cabri.emsc._free(newCoords1);
        }
        return this.updatedInLastCycle;
    }

    createMesh2 () {
        if (this.mesh2) {
            this.mesh2.dispose(false, true);
        }
        if (this.noDisplay || this.hidden) return;

        let vertexData = this.createVertexData2();
        //this.mesh2 = new BABYLON.Mesh(this.name, cabri.scene, null, null, null);
        this.mesh2 = new BABYLON.Mesh(this.name)    //, cabri.scene, null, null, null);
        vertexData.applyToMesh(this.mesh2, true);

        //super.markColor(this.mesh, this.color,  {alpha: 0.9});
        let mat = cabri.stdBlackMaterial.clone("");

        this.mesh2.material = mat
        this.mesh2.material.diffuseColor = BABYLON.Color3.FromHexString(this.color);
        this.mesh2.material.emissiveColor = BABYLON.Color3.FromHexString(this.color);

        //this.mesh2.material.emissiveColor.scale(0.08)
        let k = 0.08;
        this.mesh2.material.emissiveColor.r *= k;
        this.mesh2.material.emissiveColor.g *= k;
        this.mesh2.material.emissiveColor.b *= k;
        //this.mesh2.material.specularColor = BABYLON.Color3.FromHexString("#101010");

        this.mesh2.material.alpha = 0.8;

        // next is to "hide" the yellow cube itself
        // normally to avoid any moiré effect we should move objects along  z-direction
        if (this.color === "#FFFF00")
            this.mesh2.isVisible = false;

        if (this.peeredClass === "subplane3") {
            let positions = this.mesh2.getVerticesData(BABYLON.VertexBuffer.PositionKind);
            let i;
            for (i = 0; i < positions.length; i += 3) {
                let absPos = positions[i + 1]
                absPos = absPos>0 ? absPos:-absPos
                if (absPos > 10e-12)
                    break;
            }
            if (i === positions.length)
                this.mesh2.position.y = 0.02
        }
    }

    createMeshes() {
        this.createMesh2();
        this.createMesh1();
//Cabrilog.log("jml red", "esssai "+ this.mesh2.position.y, 2)
    }

    createMesh1() {             // carefull this will be an array of meshes !!
        if (this.meshs1) {
            for(let m of this.meshs1)
                m.dispose(false, true);
        }
        if(!this.drawDim1 || this.noDisplay || this.hidden) return;

        let c = this.rawCoords1;
        const numTubes = c.length/6;
        if (this.meshs1.length !== numTubes)
            this.meshs1 = new Array(numTubes);
        const tubes = this.meshs1;
        for ( let i=0; i<numTubes; i++) {
            const p = i*6;
            const pointA = new BABYLON.Vector3(c[p  ], c[p+2], c[p+1]),
                  pointB = new BABYLON.Vector3(c[p+3], c[p+5], c[p+4]);
            const tube = tubes[i] = BABYLON.MeshBuilder.CreateTube(
                "MeshEdge" + this.objectId,
                {
                    path: [pointA, pointB],
                    radius: 0.05*this.curve_radius,
                    tesselation: 4,  // default is 64
                    updatable: true
                });
            super.markColor(tube, this.curveColor);
            tube.pointA = pointA;
            tube.pointB = pointB;
        }
    }

    createVertexData2 () {
        /*
         a b c d e f g h i => a b c d e f g h i g h i d e f a b c
         ... and indices   => 1     2     3     4     5     6
         */
        const newCoords = this.rawCoords2;
        const numT = newCoords.length / 9;         // number of triangles  (each triangle has 3 points with 3 coordinates => 9)
        const c = new Array(numT*9*2);  // *2 to be double-sided
        // insert points for each triangle clockwise and anti-clockwise
        for (let i = 0; i < numT; i++) {           // i: number of the triangle
            const vJ1 = 18*i,
                  vJ2 = 18*i + 9;                  // index start within c
            for (let vN = 0; vN < 3; vN++) {      // vertex-num on the triangle
                c[vJ1 + 3*vN    ] = c[vJ2 + 3*(2 - vN)    ] = newCoords[9*i + 3*vN    ];
                c[vJ1 + 3*vN + 1] = c[vJ2 + 3*(2 - vN) + 1] = newCoords[9*i + 3*vN + 2];
                c[vJ1 + 3*vN + 2] = c[vJ2 + 3*(2 - vN) + 2] = newCoords[9*i + 3*vN + 1];
            }
        }
        const indices = new Array(numT*3 * 2);    // twice 3 indices per triangle
        for (let l = 0; l < numT*6; l++)
            indices[l] = l;

        const vertexData = new BABYLON.VertexData();
        vertexData.positions = c;
        vertexData.indices = indices;
        vertexData.normals = [];
        BABYLON.VertexData.ComputeNormals(c, indices, vertexData.normals);
        return vertexData;
    }

    /** Called when the mesh's number of points isn't changed and thus nothing
     * of the vertex data needs a change. */
    updateMeshes () {
        // faces
        const vertexData = this.createVertexData2();
        if(vertexData.positions.length===0) {
            this.setMeshVisible(false);
            return;
        }

        /* let coords = vertexData.positions;
        for (let i = 0; i < coords.length; i++) {
            coords[i] = this.newCoords[i];
        }*/
        if(this.mesh2)          // JML why this "if" ??
            vertexData.applyToMesh(this.mesh2, true);

        // edges
        /*
        let c = this.rawCoords1;
        const numTubes = c.length/6;
        const tubes = this.meshs1;
        for (let i=0; i<numTubes; i++) {
            const m = tubes[i], p = 6*i;
            const a = m.pointA, b = m.pointB;
            a.x =  c[p  ]; a.y = c[p+2]; a.z = c[p+1];
            b.x =  c[p+3]; b.y = c[p+5]; b.z = c[p+4];
            //m.updateVerticesData(BABYLON.VertexBuffer.PositionKind,
            //    [a.x, a.y, a.z, b.x, b.y, b.z]);
        } */
        this.createMesh1();
        if(!this.hidden && !this.noDisplay)
            this.setMeshVisible(true)
        //this.mesh2.position.y = 0.02
    }

    setMeshVisible(visible) {
        if(this.mesh2)
            this.mesh2.isVisible =visible;
        if(this.meshs1)
            this.meshs1.forEach((m)=> {m.isVisible = visible; });
    }

} // ends class RenderableMesh

export {RenderableMesh};